<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="56"
    viewBox="8 -4 56 56"
  >
    <g filter="url(#filter0_dd_4462_8303)">
      <circle
        cx="36"
        cy="24.5"
        r="24"
        fill="white"
      />
      <path
        d="M45.75 23.2424C46.75 23.8013 46.75 25.1987 45.75 25.7576L32.25 33.3033C31.25 33.8622 30 33.1635 30 32.0457L30 16.9543C30 15.8365 31.25 15.1378 32.25 15.6967L45.75 23.2424Z"
        fill="#15172F"
      />
    </g>
    <defs>
      <filter
        id="filter0_dd_4462_8303"
        x="0"
        y="0.5"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="2"
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_4462_8303"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4462_8303"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_4462_8303"
        />
        <feOffset dy="12" />
        <feGaussianBlur stdDeviation="8" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_4462_8303"
          result="effect2_dropShadow_4462_8303"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_4462_8303"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
